import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock, Facebook, Instagram } from "lucide-react";
import { NAV } from "@/lib/site";
import { useContent, buildWa } from "@/lib/ContentProvider";

const TREATMENTS = [
  "Laser Piles Treatment", "Varicose Veins (EVLT)", "Laser Fissure Treatment",
  "Laser Fistula (FiLaC)", "Pilonidal Sinus", "Laparoscopic Surgery",
  "Laser Cosmetic Gynaecology", "General Physician",
];

export default function Footer() {
  const { siteConfig } = useContent();
  return (
    <footer data-testid="site-footer" className="relative bg-alch-forest text-alch-bg">
      <div className="mx-auto max-w-7xl px-5 py-20 md:px-8">
        <div className="grid gap-14 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3">
              {siteConfig.logo ? (
                <img src={siteConfig.logo} alt="ALCH" className="h-11 w-11 rounded-full object-cover bg-alch-bg" />
              ) : (
                <span className="grid h-11 w-11 place-items-center rounded-full bg-alch-bg text-alch-forest font-serif text-lg font-semibold">A</span>
              )}
              <span className="font-serif text-2xl">ALCH</span>
            </div>
            <p className="mt-6 max-w-xs text-sm leading-relaxed text-alch-bg/70">
              {siteConfig.name || "Advanced Laser Care Hospital"} — Kumaon region&rsquo;s leading centre for minimally invasive laser and laparoscopic surgical care.
            </p>
            <div className="mt-6 flex gap-3">
              <a href={siteConfig.facebook} target="_blank" rel="noreferrer" aria-label="Facebook" className="grid h-10 w-10 place-items-center rounded-full border border-alch-bg/20 transition-colors hover:bg-alch-terracotta hover:border-alch-terracotta">
                <Facebook className="h-4 w-4" />
              </a>
              <a href={siteConfig.instagram} target="_blank" rel="noreferrer" aria-label="Instagram" className="grid h-10 w-10 place-items-center rounded-full border border-alch-bg/20 transition-colors hover:bg-alch-terracotta hover:border-alch-terracotta">
                <Instagram className="h-4 w-4" />
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] text-alch-terracotta">Quick Links</h4>
            <ul className="mt-6 space-y-3 text-sm">
              {NAV.map((n) => (
                <li key={n.to}>
                  <Link to={n.to} className="text-alch-bg/75 transition-colors hover:text-alch-bg">{n.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] text-alch-terracotta">Our Treatments</h4>
            <ul className="mt-6 space-y-3 text-sm">
              {TREATMENTS.map((t) => (
                <li key={t} className="text-alch-bg/75">{t}</li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] text-alch-terracotta">Reach Us</h4>
            <ul className="mt-6 space-y-4 text-sm text-alch-bg/75">
              <li className="flex gap-3"><MapPin className="mt-0.5 h-4 w-4 shrink-0 text-alch-terracotta" /><span>{siteConfig.address}</span></li>
              <li className="flex gap-3"><Phone className="h-4 w-4 shrink-0 text-alch-terracotta" /><a href={`tel:${siteConfig.phoneRaw}`}>{siteConfig.phone}</a></li>
              <li className="flex gap-3"><Mail className="h-4 w-4 shrink-0 text-alch-terracotta" /><a href={`mailto:${siteConfig.email}`}>{siteConfig.email}</a></li>
              {siteConfig.hours && (
                <li className="flex gap-3"><Clock className="h-4 w-4 shrink-0 text-alch-terracotta" /><span>{siteConfig.hours}</span></li>
              )}
            </ul>
            <a href={buildWa(siteConfig.whatsapp)} target="_blank" rel="noreferrer" data-testid="footer-book" className="mt-6 inline-block rounded-full bg-alch-terracotta px-6 py-3 text-sm font-medium text-white transition-transform hover:scale-[1.04]">
              Book on WhatsApp
            </a>
          </div>
        </div>

        <div className="mt-16 flex flex-col items-center justify-between gap-4 border-t border-alch-bg/15 pt-8 text-xs text-alch-bg/55 md:flex-row">
          <p>© 2026 {siteConfig.name || "Advanced Laser Care Hospital"}, Haldwani. All Rights Reserved.</p>
          <p>{siteConfig.tagline}</p>
        </div>
      </div>
    </footer>
  );
}
